module.exports = {
  localeName: 'de-DE',
  momentFormat: 'DD.MM.YYYY'
};
